import PropTypes from 'prop-types';
import React from 'react';
import HorizontalBar from '../HorizontalBar/HorizontalBar';
import './ContentContainerSideBar.scss';

export default class ContentContainerSideBar extends React.PureComponent {
    /**
     * Layout option with sidebar
     */
    constructor(props) {
        super(props);
        this.state = {
            sidebarWidthStyle: {},
            fixed: '',
        };
    }

    static propTypes = {
        /**
         * The Child components to be the content of the layout
         */
        children: PropTypes.node.isRequired,
        /**
         * SideBar Content
         */
        sideBarContent: PropTypes.node,
        /**
         * HorizontalBarContent
         */
        horizontalBarContent: PropTypes.node,
        /**
         * Whether or not the sidebar sticks
         */
        sideBarFixed: PropTypes.bool,
        /**
         * Full URL of current page
         * Whether or not the sidebar sticks
         */
        sideBarStick: PropTypes.bool,
        /**
         * main section col-class
         */
        mainSectionColClass: PropTypes.string,
        /**
         * sidebar col-class
         */
        sidebarColClass: PropTypes.string,
        /**
         * Full URL of current page
         */
        currentURL: PropTypes.string,
        /**
         * Base URL of Current Page.
         */
        baseURL: PropTypes.string,
    };

    static defaultProps = {
        currentURL: '/',
        baseURL: '/',
        mainSectionColClass: 'col-xl-9',
        sidebarColClass: 'col-xl-3',
        sideBarContent: <div></div>,
        horizontalBarContent: <div></div>,
        sideBarFixed: false,
        sideBarStick: false,
    };

    componentDidMount() {
        window.addEventListener('scroll', this.sideScroll);
        window.addEventListener('resize', this.sideScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.sideScroll);
        window.removeEventListener('resize', this.sideScroll);
    }

    setRef = (node) => {
        this.ref = node;
    };

    setRef2 = (node) => {
        this.ref2 = node;
    };

    sideScroll = () => {
        if (!this.ref || !this.ref2) {
            return;
        }
        let ref1 = this.ref.getBoundingClientRect();
        let ref2 = this.ref2.getBoundingClientRect();
        let newFixed = null;

        if (this.state.sidebarWidthStyle.width !== `${ref1.width}px`) {
            this.setState({ sidebarWidthStyle: { width: `${ref1.width}px` } });
        }

        if (this.props.sideBarFixed) {
            if (ref1.top <= 0 && ref2.bottom >= 758) {
                newFixed = 'fixedSide';
            } else if (ref2.bottom <= 727) {
                newFixed = 'stuckToBottom';
            } else {
                newFixed = null;
            }
        }

        if (this.state.fixed !== newFixed) {
            this.setState({
                fixed: newFixed,
            });
        }
    };

    render() {
        return (
            <div
                className="components-Layout-ContentContainerSideBar"
                style={{ minHeight: '500px' }}
            >
                <div className="mainDisplay p-0">
                    <div className="row">
                        <div
                            ref={this.setRef2}
                            className={`layoutContent col-12 ${this.props.mainSectionColClass}`}
                        >
                            <span className="childrenDisplay">
                                {this.props.children}
                            </span>
                            <div className="row d-xl-none m-0 no-gutters">
                                <div className="col-12 pt-3 horizontalBar">
                                    <HorizontalBar
                                        content={
                                            this.props.horizontalBarContent
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className={`sidebar ${this.props.sidebarColClass} d-none d-xl-block`}
                        >
                            <div ref={this.setRef} className="ref1">
                                <div className="absolute">
                                    <div
                                        className={`sideState ${this.state.fixed}`}
                                        style={this.state.sidebarWidthStyle}
                                    >
                                        {this.props.sideBarContent}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
